import { render, staticRenderFns } from "./AssetControl.vue?vue&type=template&id=40fb163d"
import script from "./AssetControl.vue?vue&type=script&lang=js"
export * from "./AssetControl.vue?vue&type=script&lang=js"
import style0 from "./AssetControl.vue?vue&type=style&index=0&id=40fb163d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.90.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports